module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/employees/employees.html
// module id = 441
// module chunks = 0